import React from 'react';
import { BaseConfig } from '../BaseConfig';
import GeneralButtonWithText from '../helpers/GeneralButtonWithText';
import { UIProperties } from '../UIProperties';

const SGAOptimizationsUI = (props: UIProperties<SGAOptimizationsUIConfig>) => {
	return (
		<div className="modal-disable-select" style={{
			position: 'absolute',
			top: '0',
			left: '0',
			width: '100%',
			height: '100%'
		}}>
			<div style={{
				position: 'absolute',
				top: '50%',
				left: '50%',
				transform: 'translate(-50%, -50%)',
				width: '870px',
				height: '550px'
			}}>
				<img style={{
					width: '100%',
					height: '70px'
				}} src="./assets/images/SBAR/header_modal_1.png"/>
				<div style={{
					position: 'absolute',
					top: '01px',
					left: '3px',
					width: '870px',
					height: '65px',
				}}>
					<p style={{
						margin: '0px',
						fontSize: '25pt',
						textAlign: 'center',
						position: 'relative',
						top: '13px'
					}} className="title-font" tabIndex={0} id='sga-optimizations-ui-top'>SGA Optimizations</p>
				</div>
				<div style={{
					width: '100%',
					height: '480px',
					position: 'absolute',
					top: '70px',
					left: '0'
				}}>
					<img style={{
						width: '100%',
						height: '100%'
					}} src="./assets/images/SBAR/window_modal_1_edited.png"/>
					<GeneralButtonWithText parameters= {{
						text: 'Change SGA Size',
						ariaLbl: 'Change SGA Size',
						top: '100px',
						left: '230px',
						width: '200px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '17pt',
							width: '76%'
						},
						onClicked: () => {
							props.parameters.onChangeSGASizeClicked();
						}
					}}/>
					<GeneralButtonWithText parameters= {{
						text: 'Up / Down Maneuver',
						ariaLbl: 'Up / Down Maneuver',
						top: '100px',
						left: '450px',
						width: '200px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%'
						},
						customButtonStyle : {
							width: '100%'
						},
						customTextStyle: {
							fontSize: '17pt'
						},
						onClicked: () => {
							props.parameters.onUpDownManeuverClicked();
						}
					}}/>
					<div style={{
						width: '510px',
						height: '10px',
						backgroundColor: '#0043A2',
						position: 'absolute',
						top: '230px',
						left: '50%',
						transform: 'translate(-50%, 0)'
					}}></div>
					<GeneralButtonWithText parameters= {{
						text: 'Choose Another Technique',
						ariaLbl: 'Choose Another Technique',
						id:'sga-optimizations-ui-bottom',
						top: '270px',
						left: '309px',
						width: '260px',
						isDisabled: false,
						srcIdle: "./assets/images/main-menu/button_menu_exit.png",
						srcHighlight: "./assets/images/main-menu/button_menu_exit_down.png",
						srcDisabled: null,
						customImgStyle: {
							width: '100%',
							height: '103px'
						},
						customButtonStyle : {
							width: '100%',
							height: '103px'
						},
						customTextStyle: {
							fontSize: '17pt'
						},
						onClicked: () => {
							props.parameters.onChooseAnotherTechniqueClicked();
						}
					}}/>
					
				</div>
				
			</div>
		</div>
	);

};

export interface SGAOptimizationsUIConfig extends BaseConfig{
	onChangeSGASizeClicked: () => void;
	onUpDownManeuverClicked: () => void;
	onChooseAnotherTechniqueClicked: () => void;
}

export default SGAOptimizationsUI;